module.exports = {
  messages: {
    CN: {
      AddLeads: "添加潜在客户",
      ChooseYourCustomerSearchMethod: "客户查找方式",
      InputBasicInformation: "基础信息录入",
      CampaignsSettings: "任务设置",
      Pleaseenterthecampaignname: "请输入任务名称",
      SaveandContinue: "保存并继续",
      back: "返回",
      SearchMethodSelection: "搜索方式选择",
      ConnectYourLinkedInAccount: "绑定领英账号",
      ConfigureLinkedInProxy: "代理设置",
      SelectfromYourConnectedContacts: "一度人脉：从你的好友中选择",
      SearchByUrl: "领英URL搜索：通过领英搜索URL寻找目标客户",
      bindLinkAcc: "绑定领英账号",
      linkEmal: "邮箱",
      linkPwd: "密码",
      timeZone: "时区",
      ConfigureLinkedInProx: "代理设置",
      ManualConfiguration: "人工配置",
      SelectProxyRegion: "代理区域",
      Connect: "连接",
      EnterLinkedInSearchURL: "请输入领英搜索URL",
      CompanyInformation: `公司介绍`,
      CompanyInformationCont: `基础信息：StrategyBrain是一家致力于通过人工智能技术提高中小企业人力资源部门员工工作能力，推动中小企业改善人力资源成本，提高中小企业市场竞争力的创新公司。
官方网站：www.strategybrain.ca
地址：StrategyBrain位于加拿大多伦多。
公司介绍：StrategyBrain致力于用最前沿的AI科技来解决实际问题，降低社会的不平等，推动社会进步。这种文化认同和社会责任感为公司在实现其使命、愿景和价值观的过程中提供了坚实的基础。`,
      ProductInformation: "产品介绍",
      ProductInformationCont: `产品功能：
 1.产品以AI的形式协助用户自动在linkedIn上找到潜在客户，自动建立联系，自动沟通产品购买意向，解答产品疑问，阐述企业发展理念，产品优势，判断客户采购意向
2. 根据企业产品待销售产品信息设计客户画像
3. 根据客户画像自动寻找客户，根据客户背景信息，设计个性化打招呼用语，自动建立联系
4. 依据待销售产品特点和客户背景信息，设计销售沟通话术，与客户自动沟通产品购买意向，解答产品疑问，阐述企业发展理念，产品优势，判断客户采购意向
产品特点：
1. AI 7*24小时全年无休，自动工作，无语言障碍全球拓展客户
2. 个性化沟通和解决方案生成，提高客户建立联系成功率及沟通成功率（英文叫engagement）
3. 通过个性化能力，引导潜在客户输出痛点，并自主地提供对应的解决方案，增加潜在客户的信任。
4. 替代销售重复性工作，聚焦销售策略和意向客户的最终沟通。
5. AI可以学习企业的信息，通过企业信息设计的销售话术和介绍企业以及案例分享。
6. 替代在LinkedIn的所有客户拓展和销售工作。
7. AI与人协同工作，将重复工作交给AI，销售聚焦在有意向客户的沟通上，提高整个产品销售的成功率。
使用方法：
1. LinkedIn账户托管给SaaS AI平台，AI Sales Rep会使用LinkedIn账户根据提供的产品资料和客户拓展要求自动检索LinkedIn潜在客户，自动沟通客户，将有购买意向的客户联系方式记录下来，使用者就可以通过联系方式直接联系客户安排进一步正式的销售沟通。
2. 在使用前需要向AI Sales Rep提供产品资料、企业资料以方便机器人能够根据产品信息提供潜在客户画像供使用者采纳或修改，以及在与潜在客户沟通时，AI可以向潜在客户介绍产品和企业，回答潜在客户问题。
3. 机器人在使用前需要设置LinkedIn账户所在地区域，以确保机器人可以添加到正确区域内客户
常见问题：
1. AI使用的是客户提供的LinkedIn账户，如果AI软件不在使用，客户可以删除相关信息，将linkedin账户收回
2. AI不会泄露账户隐私和密码，因为AI有隐私保护设计，每一位客户的信息都会被去除敏感信息后单独加密存储
3. Saas软件不需要安装，对电脑配置没有要求，兼容windows和Mac，甚至手机都可以访问
4. AI平台可以个人使用，也可以团队使用，多LinkedIn账户使用
5. AI软件使用不复杂，非常简单，只需要提供LinkedIn账户根据系统提示进行信息录入既可以开始使用`,
      CompetitorInformation: "竞品信息",
      CompetitorInformationCont: "竞品名称：dux-soup,Expandi.io,meetalfred",
      SuccessStories: "成功案例",
      SuccessStoriesCont: `case1:Cost Reduction and Efficiency: AI Sales Tools Enhance HR Productivity and Employee Satisfaction
Implementing AI sales tools can significantly reduce costs and improve efficiency, enhancing HR productivity and employee satisfaction. BridgePoint B2B Leads Solutions integrated StrategyBrain’s AI Sales Rep to address challenges such as high management costs, employee turnover, operational inefficiencies, and limited revenue growth. The AI’s capabilities in customer profiling, personalized outreach, and 24/7 sales conversations allowed the sales team to shift from repetitive tasks to strategic sales, greatly improving overall efficiency and reducing operational expenses. As a result, the implementation led to a 60% reduction in operational costs, a 20% increase in employee satisfaction, and a 5% revenue growth, successfully driving the company's expansion in the global market.
case2：......`,
      PricingInformation: "价格信息",
      PricingInformationCont: `免费试用：免费测试使用，可以直接注册并体验产品
付费价格：每月9.9美元价格
是否优惠：是，订购可享受每月9.9美元`,
      ContactInformation: "联系方式",
      ContactInformationCont: `邮箱：
电话：`,
      addMore: "添加更多信息",
      CustomContent: "自定义内容",
      inputCustomContent: "请输入自定义内容",
      BriefSummary: "简短总结",
      BriefSummaryIntro: `简短总结能够帮助strategyBrain更好的理解你的公司和产品，请确保包含所有的关键点`,
      SetConversationLimits: "对话限制",
      SetConversationLimitsCont:
        "在这里你可以设置机器人可以说什么以及不能说什么的限制。例如：不要给用户讲笑话。不涉及政治内容",
      sendLimit: "每日发送添加好友请求数",
      dianzan: "给用户的第一条post点赞",
      capaginName: "任务名称",

      inputLinkAccount: "请选择LinkedIn账号",
      inputContent: "请输入内容",
      rightAccount: "请输入正确的邮箱领英账号",
      inputPwd: "请输入密码",
      selectTimezone: "请选择时区",
      selectRegion: "请选择代理区域",
      selectUrl: "请输入正确的LinkedIn URL",
      editTitle: "请编辑自定义标题",
      shortDes: "请输入简短总结",
      dialogLimit: "请输入对话限制",
      All: "所有的",
      bindTips:
        "请准备好确认您LinkedIn账户的PIN码。该PIN码将由LinkedIn发送到LinkedIn账户的邮箱，具体取决于安全设置，也可能通过短信发送。",
      inputCode: "请输入验证码",
      confirmDel: "确认要删除此任务",
      NextStep: "下一步",

      Account: "账号",
      TimeZone: "时区",
      Proxy: "代理",
      Connected: "已连接",
      ObtainProxyIP: "获取代理IP",
      VerifyLink: "校验LinkedIn账号密码",
      LinkedInAccountLink: "LinkedIn账号链接",
      ContinueConnect: "继续链接",
      selectHistory: "可以选择历史记录",
      findUrl: "如何找到LinkedIn URL",
      loginAccount: "登录您的LinkedIn账号",
      Enterkeywords: "在搜索框中输入关键词，点击enter或者see all results",
      SelectThePeople:
        "选择people筛选，同时在Filter中设置更多搜索条件，点击show results",
      copyURL: "复制导航栏中的URL地址，到此输入框中",
      ReferenceDocument: "参考文档",
      conversationRestrictions: "例如，拒绝讲笑话",
      Save: "保存",
      SelectThePeopleRed:
        '请注意：在使用Filter时，请进行connections的选择，如果您想让机器人给已有好友发送消息，则勾选上1st。如果不想让机器人给已有好友发送消息，请取消选中，只选择2nd和3rd+。"',
      bindLinkAccTipTitle1: "如何绑定LinkedIn账号？",
      bindLinkAccTipcon1:
        "输入您正确的LinkedIn账号，密码，并选择时区和代理，点击开始连接，系统会开始进行LinkedIn账号的校验。如遇中断，请根据提示进行操作。仍无法绑定成功，可联系我们的客户支持。",
      bindLinkAccTipTitle2: "是否支持所有类型的LinkedIn账号？",
      bindLinkAccTipcon2:
        "不是。在绑定LinkedIn账号的时候，请先校验下您的账号是否支持添加好友，若您的账号暂时无法添加好友，创建任务后机器人将无法执行该任务。",
      bindLinkAccTipcon3:
        "您可以先提升LinkedIn的活跃度，例如完善个人资料，发布分享内容，积极与他人互动等。解锁添加好友的权限后再进行尝试。",
      bindLinkAccTipBtn: "点击",
      bindLinkAccTipBtnTxt: "查看详情文档",
      step3TipTitle: "添加好友限制",
      step3TipCon:
        "  为了防止触发LinkedIn账号风控，请尽量控制每个账号每日添加好友的上限，",
      step3TipCon1:
        "普通账号每日最好不要超过20人，navigator账号每日最好不要超过35人。",
      step3TipTitle2: "账号工作时间",
      step3TipCon2:
        "每个LinkedIn账号会根据您绑定账号时选择的代理区域，按照当地的工作时间实行8小时工作制。账号会在工作时间内执行搜索，添加好友，与好友对话等事项，超出工作时间将暂停工作，直至第二天工作时间重新开启。",
      Confirm: "确认",
      Cancel: "取消",
      TheAccountIsBeingBound: "账号正在绑定中，确认要离开么?",
      campaignEditStep2Tip:
        "修改内容可能会干扰AI与用户的对话，导致上下文不匹配或对话断裂。请小心编辑，仅做小幅调整，避免改变主题。",
      saveDraftBtn: "保存草稿",
      saveDraftSuccess: "已保存至草稿箱",
      InitialGreetingLanguage: "打招呼语言",
      InitialGreetingLanguageErr: "请选择打招呼语言",
      PublishDirectly: "直接发布",
      ViewSimulation: "观看模拟",
      PreReviewEyebrow: "推荐下一步",
      PreReviewTitle: "设置完成，可以进行发布前审核",
      PreReviewDesc:
        "我们会获取真实潜在客户并生成预览。暂时不会发送任何消息；未绑定付款方式的用户仍需在发布前确认付款方式。",
      PreLaunchReview: "发布前审核",
      AfterReview: "审核后",
      AIStyleSettings: "AI 风格设置",
      step3NoteTipTitle: "请注意",
      step3TipDes1: `“保存草稿”将该活动存储在草稿箱中，以便稍后编辑和发布。`,
      step3TipDes2: `“观看模拟”让您查看AI如何根据您的输入与用户互动，之后可以发布。`,
      step3TipDes3: `“直接发布”跳过模拟并立即发布。`,
      step3TipDes4: `请注意，如果客户首次回复消息的语言与AI Agent使用的语言不同，AI Agent将自动切换为与客户一致的语言进行交流。`,
      step3TipDes5: `AI模拟对话并不完全代表AI Agent真实的交互过程，因为它取决于实际的客户背景和对话语境。该功能主要让您大致了解AI Agent的交流能力，帮助您为应用做好准备。`,
      CampaignsSimulation: "对话模拟",
      step4Des:
        "我们根据您的输入模拟AI如何一步步实现您的业务目标。模拟对话根据选定的用户资料和您提供的信息进行个性化。如果结果不符合您的预期，您可以调整输入，直到达到预期效果。",
      noFirstCampaignTip:
        "您现在是免费试用版本，请升级账号，可创建无限campaign。",
      LinkedinAvailabilitySchedule: "LinkedIn工作计划",
      AlwaysOn: "24/7 全天候运行",
      BusinessHoursMS: "周一至周五，上午 8 点至晚上 7 点",
      BusinessHoursMF: "周一至周日，上午 8 点至晚上 7 点",
      workTimeDes:
        "24/7 或每周一至周日（全天候）的活动可能会触发 LinkedIn 系统的风险提示。请验证您的账户以避免封禁风险。",
      verifyyourLinkedIn: `在使用任何第三方自动化工具前，请先验证您的领英账号。详见<a href="https://www.strategybrain.ca/a-practical-guide-to-linkedin-verification-and-recovery-for-strategybrain-users/" target="_blank">《领英账号验证教程》</a>。`,
      Avoidswitchingaccounts: `请避免频繁切换账号，以免增加风险。如需切换账号，请<a href="mailto:info@strategybrain.ca" target="_blank">联系我们</a>（可能产生少量服务费）。`,
      In: "启用",
      Out: "禁用",
      OptInOut: "选择启用/禁用",
      SetFollowMessageStatus: "设置跟进消息状态",
      Yes: "启用",
      No: "禁用",
      SetIntervaldays: "设置跟进消息间隔天数",
      SettingFollowMessage:
        "设置跟进消息间隔，AI Agent将在指定时间间隔自动向潜在联系人发送跟进消息。这确保了及时互动并提高了响应率，无需手动跟进。",
      PleaseEnterInter: "请输入一个正整数",
      SendNote: "添加联系人时发送备注",
      cyes: "是",
      cno: "否",
      selectNotType: "选择备注类型",
      pointsolution: "痛点解决方案",
      Competitorcomparison: "竞品对比",
      Scenario: "场景假设",
      Admiration: "赞赏与经验",
      relationship: "长期关系",
      introduction: "自我介绍",
      Customcontent: "自定义内容",
      noteTips:
        "1)备注内容会根据每个联系人请求自动个性化。以下示例仅供参考。2)免费LinkedIn账号每天可发送一条请求备注；Premium会员无限制。3)免费账号备注限制200字符，Premium会员300字符。",
      example: "示例",
      GenerateExample: "生成示例",
      Notecontent: "备注内容",
      JustEnter: "只需输入以下内容——无需输入姓名或其他字段，AI将自动填充。",
      PositionOpportunity: "职位机会",
      Achievement: "成就赞赏",
      IndustryInsight: "行业洞察",
      TalentCommunity: "人才社区",
      required: "该项为必填项",
      ConsultationReport: "咨询报告",
      StepHintTitle: "第 1 步（共 5 步）：命名 + 绑定 LinkedIn",
      StepHintDesc: "只需跟随指引 — 大约 2 分钟即可让 AI 开始为您工作！",
      ProHintBtnShow: "我是专家，最小化提示",
      ProHintBtnHide: "已最小化 · 显示完整说明",
      SafeCardHeader: "为什么需要连接？是否安全？",
      SafeCardIntro: "连接 LinkedIn 以开始自动化拓展。以下是我们如何确保您的账户 100% 安全：",
      SafeItemProxyTitle: "专用代理 IP",
      SafeItemProxyDesc: "匹配您通常的登录位置，模拟本地登录",
      SafeItemRateTitle: "类人速率限制",
      SafeItemRateDesc: "以自然的人类节奏发送，保持在限制范围内",
      SafeItemEncryptTitle: "加密存储",
      SafeItemEncryptDesc: "凭据已加密；绝不会执行任何无关操作",
      SafeItemDisconnectTitle: "随时断开",
      SafeItemDisconnectDesc: "一键撤销访问权限",
      LearnMoreLink: "了解我们如何保护您的账户 →",
      FaCodeBoxTitle: "LinkedIn 需要验证码（双重验证）",
      FaCodeBoxDesc: `为确认是您本人，LinkedIn 刚刚发送了一个<strong class="faCodeBox-bold">6 位验证码</strong>。请检查以下<strong class="faCodeBox-bold">任意渠道</strong>并输入 — 这是正常的安全检查，<strong class="faCodeBox-bold">不是错误</strong>。`,
      FaCodeChannelAppTitle: "LinkedIn 应用推送",
      FaCodeChannelAppDesc: "打开已登录的 LinkedIn 应用并点击「是」；无需输入验证码",
      FaCodeChannelEmailTitle: "注册邮箱",
      FaCodeChannelEmailDesc: "检查收件箱或垃圾邮件文件夹中的 LinkedIn 验证码",
      FaCodeChannelAuthTitle: "验证器应用",
      FaCodeChannelAuthDesc: "打开您绑定的验证器应用并输入当前的 6 位验证码",
      FaCodeChannelSmsTitle: "短信",
      FaCodeChannelSmsDesc: "查找发送到 LinkedIn 绑定手机号的 6 位验证码",
      FaCodeViewLarger: "查看大图 →",
      FaCodeInputLabel: "如果 LinkedIn 要求验证码，请输入 6 位数字",
      LinkedinAccountLabel: "LinkedIn 账号",
      LinkedinEmailPlaceholder: "输入您的 LinkedIn 登录邮箱",
      PasswordLabel: "密码",
      PasswordPlaceholder: "您的 LinkedIn 密码",
      PasswordTipText: `点击 <span class="eye">👁</span> 显示并仔细检查是否有拼写错误。`,
      TimeZoneLabel: "时区",
      TimeZoneTag: "已根据您的位置选择",
      TimeZoneTipText: `选择您或目标候选人的时区；AI 会在<strong class="input-tip-bold">当地白天时间</strong>发送消息 — 更人性化且更安全。`,
      ProxyRegionLabel: "代理区域",
      ProxyRegionTag: "推荐",
      ProxyRegionPlaceholder: "美国 · 匹配您通常的登录地",
      ProxyRegionTipText: `最好匹配<strong class="input-tip-bold">您通常登录 LinkedIn 的地区</strong>，以避免因异地登录触发风控。`,
      WorkingHoursLabel: "工作时间",
      WorkingHoursTag: "新账号推荐",
      WorkingHoursPlaceholder: "工作日 · 白天时段（更安全）",
      WorkingHoursTipText: `<strong class="input-tip-bold">不要让新账号 24/7 运行</strong> — 工作日白天看起来更像人类行为，降低封号风险；等账号养熟后再逐步放开。`,
      FaTipsText: `连接时，LinkedIn 可能会要求提供<strong class="faTips-bold">验证码（双重验证）</strong>。会出现一个验证码输入框，告诉您在哪里找到它 — <strong class="faTips-bold">应用推送 / 注册邮箱 / 短信</strong> — 所以您永远不会卡住。`,
      CampaignNameTipText: `选择一个容易识别的名称 — 它<strong class="input-tip-bold">使管理多个任务更容易；</strong>按角色/地区命名效果最佳。`,
      Step2HintTitle: "第 3 步（共 5 步）：清晰描述您的公司、产品和优势，以便 AI 精准触达客户、回答问题并促成交易。",
      Step2HintDesc: `每个字段都有"如何填写 + AI 如何处理"的说明。您提供的信息越具体，AI 的拓展和回复就越可靠。`,
      CompanyInfoTipText: `AI 将其作为<strong class="input-tip-bold">开场白的背景</strong>，并用于回答“贵公司是做什么的？”已从您的资料预填 — 请针对本次任务的目标客户进行调整。`,
      ProductInfoTipText: `请明确说明<strong class="input-tip-bold">功能 + 解决的问题 + 核心优势</strong>。AI 用它来判断匹配度、生成<strong class="input-tip-bold">个性化拓展</strong>，并回答产品问题 — 这是销售流程中最重要的字段。`,
      CompetitorInfoTipText: `列出主要竞争对手。当客户<strong class="input-tip-bold">提及或比较他们</strong>时，AI 知道如何回应并突出您的<strong class="input-tip-bold">差异化优势</strong>，而不会卡住。`,
      SuccessStoriesTipText: `添加 1-2 个<strong class="input-tip-bold">客户成果/指标</strong>。AI 会在<strong class="input-tip-bold">合适的时机</strong>使用它们来提升可信度和转化率。`,
      PricingInfoTipText: `添加如<strong class="input-tip-bold">免费试用、定价和限时优惠</strong>等钩子。当客户感兴趣时，AI 会<strong class="input-tip-bold">主动提及</strong>以推动下一步（试用/下单）。`,
      ContactInfoTipText: `留下<strong class="input-tip-bold">邮箱/电话</strong>。当客户感兴趣时，AI 会分享它以推进交易 — <strong class="input-tip-bold">至少输入一个邮箱</strong>。`,
      CustomContentTipText: `AI 还应该知道的其他信息（例如<strong class="input-tip-bold">行业、理想客户画像、价格范围</strong>）— 点击添加，AI 将用它来回答问题并促成交易。`,
      EndTipsInfoText: `此信息仅用于帮助 AI 了解您的公司和产品；<strong class="end-tips-bold">绝不会直接向客户展示原文</strong>；AI 会在上下文中自然地引用它。`,
      Step4HintTitle: "第 4 步（共 5 步）：设置 AI 如何开场、跟进以及它的硬性限制。",
      Step4HintDesc: `这是发布前的最后一步。每个项目都有说明；设置完成后，您可以“观看模拟”来确认后再发布。`,
      GreetingLanguageLabel: "打招呼语言",
      GreetingLanguageTipText: `AI <strong class="input-tip-bold">第一条连接消息</strong>的语言，请匹配您的目标候选人（北美地区用英语）。一旦他们回复，AI 会自动跟随他们的语言。`,
      FollowUpMessagesLabel: "跟进消息",
      FollowUpMessagesEnabled: "启用",
      FollowUpMessagesDisabled: "禁用",
      FollowUpMessagesTipText: `开启后，如果在下方间隔时间内没有回复，AI 会<strong class="input-tip-bold">自动跟进</strong>，提高回复率；关闭时，只发送一条连接消息。`,
      FollowUpIntervalLabel: "跟进间隔（天）",
      FollowUpIntervalTipText: `我们建议每<strong class="input-tip-bold">3-5 天</strong>；太频繁会惹人厌烦并触发风控。（跟进关闭时无效。）`,
      SendNoteLabel: "添加联系人时发送备注",
      SendNoteTipText: `在连接请求中附上<strong class="input-tip-bold">简短备注</strong>可提高回复率。免费 LinkedIn 账号每天可发送 1 条带备注的请求；Premium 无限制。`,
      NoteTypeLabel: "备注类型",
      NoteTypeTipText: `按目标选择模板；AI 会<strong class="input-tip-bold">为每个联系人生成个性化备注</strong>。&nbsp;&nbsp;<strong class="input-tip-bold green">招聘</strong>：职位机会/人脉拓展...<strong class="input-tip-bold green">销售</strong>：痛点解决/竞品对比...（仅此字段的备注因角色而异；所有其他字段相同）`,
      NoteTipsText: `关于字符限制：免费 LinkedIn 账号每天可发送<strong>1</strong>条带备注的请求，备注上限<strong>200 字符</strong>；Premium 账号<strong>请求无限制</strong>，消息上限<strong>300 字符</strong>。备注会为每位候选人个性化；以下示例仅供参考。`,
      GeneratedExampleLabel: "生成的示例",
      GeneratedExampleTag: "根据以上信息自动生成",
      GeneratedExampleTipText: `这是 AI 根据以上信息生成的<strong class="input-tip-bold">真实示例</strong>。要查看完整的来回对话，请点击下方的“观看模拟”。`,
      ConversationRulesLabel: "对话规则（AI 的硬性限制）",
      ConversationRulesTipText: `在此设置 AI <strong class="input-tip-bold">能做什么和不能做什么</strong>。`,
      SkipAllTutorials: "跳过所有教程",
      TutorialStep2Desc: "输入您的任务名称。",
      TutorialStep3DescWithLink: `选择一个 LinkedIn 账号，然后点击“下一步”。`,
      TutorialStep3DescNoLink: `<div class="setp1-linkin-txt">输入您的 LinkedIn 账号和密码，以便系统代表您发送消息。</div><div class="setp1-linkin-txt">选择您的潜在候选人的主要时区。</div><div class="setp1-linkin-txt">选择与您的 LinkedIn 账号通常登录位置匹配的代理 IP。</div>`,
      TutorialStep4Desc: "输入 AI 对话所需的 URL 和知识库内容。每个字段输入越详细，AI 的回复就越准确。",
      TutorialStep4Desc2: "这些信息仅用于 AI 与客户的对话，请放心填写。",
      TutorialStep4HowToFindUrl: "如何找到基本搜索 URL？",
      TutorialStep4FindUrl1: `输入关键词，选择"People"，并通过筛选缩小潜在客户范围。`,
      TutorialStep4FindUrl2: "复制链接并粘贴到此处。",
      TutorialStep4HowToFindSalesNavUrl: "如何找到 Sales Navigator 搜索 URL？",
      TutorialStep4SalesNav1: "打开浏览器并访问：https://www.linkedin.com/sales/。",
      TutorialStep4SalesNav2: "登录您的 Sales Navigator 账号。",
      TutorialStep4SalesNav3: "输入关键词并按 Enter。",
      TutorialStep4SalesNav4: "使用筛选器查找潜在客户。复制 URL 并粘贴到此处。",
      TutorialStep5Title1: "1. 初始打招呼语言",
      TutorialStep5Desc1: "选择 AI 问候用户的语言，确保其与您受众的特定语言区域相匹配。例如，对于中东客户，默认语言将是英语。",
      TutorialStep5Title2: "2. 设置每日发送的连接数",
      TutorialStep5Desc2: "定义每日发送的连接请求数量，以保持适当的任务节奏。",
      TutorialStep5Title3: "3. 按钮说明：",
      TutorialStep5Desc3: "• 保存草稿：将当前设置保存为草稿，以便您稍后编辑和发布。",
      TutorialStep5Desc4: "• AI 对话模拟：预览 AI 与模拟用户的交互，以概述它如何在真实对话中参与。这有助于识别任何缺失的知识输入。",
      TutorialStep5Desc5: "• 直接发布：立即发布任务并将当前设置应用于实际操作。",
    },
    US: {
      AddLeads: "Add Leads",
      ChooseYourCustomerSearchMethod: "Choose Your Customer Search Method",
      InputBasicInformation:
        "Input Basic Information Before Launching Campaigns",
      CampaignsSettings: "Campaigns Settings",
      Pleaseenterthecampaignname: "Please enter the campaign name",
      SaveandContinue: "Save and Continue",
      back: "Back",
      SearchMethodSelection: "Search Method Selection",
      ConnectYourLinkedInAccount: "Connect Your LinkedIn Account",
      ConfigureLinkedInProxy: "Configure LinkedIn Proxy",
      SelectfromYourConnectedContacts: "Select from Your Connected Contacts",
      SearchByUrl: "LinkedIn URL Search: Find Target Customers via URL",
      bindLinkAcc: "Connect Your LinkedIn Account",
      linkEmal: "LinkedIn Email Address",
      linkPwd: "LinkedIn Password",
      timeZone: "Select Your Time Zone",
      ConfigureLinkedInProx: "Configure LinkedIn Proxy",
      ManualConfiguration: "Manual Configuration",
      SelectProxyRegion: "Select Proxy Region",
      Connect: "Connect",
      EnterLinkedInSearchURL: "Enter LinkedIn Search URL",
      CompanyInformation: `Company Information`,
      CompanyInformationCont: `Basic Information: StrategyBrain is an innovative company dedicated to enhancing the capabilities of HR departments in SMEs through artificial intelligence, reducing HR costs, and boosting the competitiveness of SMEs in the market.
Official Website: www.strategybrain.ca
Address: StrategyBrain is located in Toronto, Canada.
Company Introduction: StrategyBrain is committed to using cutting-edge AI technology to solve real-world problems, reduce social inequalities, and foster social progress. Our culture of identification and sense of social responsibility solidly underpins our mission, vision, and values.`,
      ProductInformation: "Product Information",
      ProductInformationCont: `Product Features:
1.Automate Customer Engagement on LinkedIn.
2.Designs customer profiles based on information about products pending sale.
3.Automated Customer Discovery and Engagement.
4.Dynamic Sales Communication Tailored by AI.
`,
      CompetitorInformation: "Competitor Information",
      CompetitorInformationCont:
        "Competitor Names: Dux-Soup, Expandi.io, MeetAlfred",
      SuccessStories: "Success Stories",
      SuccessStoriesCont: `case1:Cost Reduction and Efficiency: AI Sales Tools Enhance HR Productivity and Employee Satisfaction
Implementing AI sales tools can significantly reduce costs and improve efficiency, enhancing HR productivity and employee satisfaction. BridgePoint B2B Leads Solutions integrated StrategyBrain’s AI Sales Rep to address challenges such as high management costs, employee turnover, operational inefficiencies, and limited revenue growth. The AI’s capabilities in customer profiling, personalized outreach, and 24/7 sales conversations allowed the sales team to shift from repetitive tasks to strategic sales, greatly improving overall efficiency and reducing operational expenses. As a result, the implementation led to a 60% reduction in operational costs, a 20% increase in employee satisfaction, and a 5% revenue growth, successfully driving the company's expansion in the global market.
case2：......`,
      PricingInformation: "Pricing Information",
      PricingInformationCont: `Free Trial: Test the product for free by directly registering and experiencing it.
Subscription Price: $9.90 per month
Discount Available: Yes, subscribe at $9.90 per month`,
      ContactInformation: "Contact Information",
      ContactInformationCont: `Email：
Phone：`,
      addMore: "Add More Information",
      CustomContent: "Custom Content",
      inputCustomContent: "Enter Custom Content",
      BriefSummary: "Brief Summary",
      BriefSummaryIntro: `A brief summary will help StrategyBrain better understand your company and products. Please ensure all key points are included.`,
      SetConversationLimits: "Set Conversation Limits",
      SetConversationLimitsCont:
        "Here you can set restrictions on what the robot can say. For example: 1. Do not tell jokes to users.  2. No political",
      sendLimit: "Set Daily Connection Request Limit",
      dianzan:
        "Automatically Like the First Post When Connecting with Potential Customers",
      capaginName: "Campaign Name",
      inputLinkAccount: "Please select your LinkedIn account",
      inputContent: "Please enter the content",
      rightAccount: "Please enter a valid LinkedIn email account",
      inputPwd: "Please enter the password",
      selectTimezone: "Please select a time zone",
      selectRegion: "Please select a proxy region",
      selectUrl: "Please enter a valid LinkedIn URL",
      editTitle: "Please edit the custom title",
      shortDes: "Please input your short description",
      dialogLimit: "Please input conversation limit",
      All: "All them",
      bindTips: `Be ready to confirm the PIN for your LinkedIn account due
                    to 2-factor authorization. It will be sent by LinkedIn to
                    the email address of the LinkedIn account. Depending on the
                    security settings it may also be sent via SMS.`,
      inputCode: "Please input code",
      confirmDel: "Are you sure you want to delete this task",
      NextStep: "Next Step",

      Account: "Account",
      TimeZone: "Time Zone",
      Proxy: "Proxy",
      Connected: "Connected",
      ObtainProxyIP: "Obtain Proxy IP",
      VerifyLink: "Verify LinkedIn Account Credentials",
      LinkedInAccountLink: "LinkedIn Account Link",
      ContinueConnect: "Continue Connect",
      selectHistory: "You can select history records",
      findUrl: "How to find the LinkedIn URL",
      loginAccount: "Log in to your LinkedIn account",
      Enterkeywords:
        'Enter keywords in the search box, then click Enter or "See all results"',
      SelectThePeople:
        'Select the "People" filter, set additional search criteria in the filters, and click "Show results"',
      copyURL:
        "Copy the URL address from the navigation bar into this input box",
      ReferenceDocument: "Reference Document",
      conversationRestrictions: "For example, refused to tell jokes",
      Save: "Save",
      SelectThePeopleRed: `Important Note: When using the Filter, please check your connections. To send messages to your existing connections, check "1st." If you don't want messages sent to your connections, uncheck this. Then, select only "2nd" and "3rd+" degree connections.`,
      bindLinkAccTipTitle1: "How to Link Your LinkedIn Account?",
      bindLinkAccTipcon1: `Enter your LinkedIn username and password. Then, select your time zone and proxy settings. Finally, click "Connect." The system will begin verifying your LinkedIn account. If the system interrupts the connection, please follow the on-screen instructions. If you still can't link your account, please contact support.`,
      bindLinkAccTipTitle2: "Are all types of LinkedIn accounts supported?",
      bindLinkAccTipcon2:
        "No. Before linking your LinkedIn account, please verify it can send connection requests. If your account can't add connections, the automation tool can't do related campaigns.",
      bindLinkAccTipcon3:
        "You can first increase your LinkedIn activity level by: Completing your profile. Posting and sharing content. Participating in interactions with others. Please try linking your account again after you can send connection requests.",
      bindLinkAccTipBtn: "Click here ",
      bindLinkAccTipBtnTxt: "to view the detailed documentation.",
      step3TipTitle: "Connection Request Limits",
      step3TipCon:
        "  To avoid triggering LinkedIn's security, please limit daily connection requests for each account.",
      step3TipCon1:
        "We recommend that users do not exceed 20 requests per day for regular accounts.We recommend that users do not exceed 35 requests per day for navigator accounts.",
      step3TipTitle2: "Account Operating Hours",
      step3TipCon2:
        "Each LinkedIn account runs on an 8-hour workday schedule. The selected proxy region determines the local time. The account will search, send connection requests, and chat during these hours. Operations will pause outside of working hours. They will resume the next business day when working hours begin again.",
      Confirm: "Confirm",
      Cancel: "Cancel",
      TheAccountIsBeingBound:
        "The account is being bound. Are you sure you want to leave?",
      campaignEditStep2Tip:
        "Modifying content may disrupt the AI-user conversation, causing context mismatches or disjointed dialogue. Please edit carefully, making only minor adjustments to avoid altering the theme.",
      saveDraftBtn: "Save as Draft",
      saveDraftSuccess: "Saved to Drafts",
      InitialGreetingLanguage: "Initial greeting language",
      InitialGreetingLanguageErr:
        "Please select initial conversations language",
      PublishDirectly: "Publish Directly",
      ViewSimulation: "AI Conversation Demo",
      PreReviewEyebrow: "RECOMMENDED NEXT STEP",
      PreReviewTitle: "Setup complete-ready for pre-launch review",
      PreReviewDesc:
        "We'll retrieve real prospects and generate a preview. No messages will be sent yet; users without a payment method will still confirm one before launch.",
      PreLaunchReview: "Pre-launch Review",
      AfterReview: "AFTER REVIEW",
      AIStyleSettings: "AI Style Setting",
      step3NoteTipTitle: "Note",
      step3TipDes1: `‘Save as Draft’ stores the campaign in the draft box for editing and publishing later.`,
      step3TipDes2: `‘AI Conversation Demo’ lets you see how the AI interacts with users based on your input. You can publish afterward.`,
      step3TipDes3: `‘Publish Directly’ skips the simulation and publishes immediately.`,
      step3TipDes4: `Please note that if a user responds for the first time in a different language than that used by the AI, the AI will automatically switch to communicate in the corresponding language.`,
      step3TipDes5: `AI demonstration dialogues are not an exact representation of real interactions, as they depend on actual client background and conversation context. This feature is designed to give customers a general understanding of AI’s communication capabilities, helping them prepare for real-world application testing.`,
      CampaignsSimulation: "Conversation Simulation",
      step4Des: `We use your input to simulate how our AI can achieve your business goals step by step. The simulated conversation is personalized based 
on the selected user profile and the information you provided. If it doesn’t meet your expectations, you can adjust the input until the 
desired outcome is achieved.`,
      noFirstCampaignTip:
        "This is a free trial version. Please upgrade your account to create unlimited campaigns.",
      LinkedinAvailabilitySchedule: "Linkedin Availability Schedule",
      AlwaysOn: "24/7 operation ",
      BusinessHoursMS: "Monday to Friday, 8 AM to  7 PM",
      BusinessHoursMF: "Monday to Sunday, 8 AM to 7 PM",
      workTimeDes:
        "24/7 or Mon-Sun activity may flag LinkedIn's system. Verify your account to avoid suspension risks.",
      verifyyourLinkedIn: `Please verify your LinkedIn account before using any third-party automation tools.<a href="https://www.strategybrain.ca/a-practical-guide-to-linkedin-verification-and-recovery-for-strategybrain-users/" target="_blank"> LinkedIn Account Verification Tutorial</a>.`,
      Avoidswitchingaccounts: `Avoid switching accounts frequently, as it increases risk. <a href="mailto:info@strategybrain.ca">Contact us </a>to switch(small service fee may applies).`,

      In: "In",
      Out: "Out",
      OptInOut: "Opt-In/Out",
      SetFollowMessageStatus: "Set Follow-up Message Status",
      Yes: "Yes",
      No: "No",
      SetIntervaldays: "Set Follow-up message Interval days",
      SettingFollowMessage:
        "Setting the follow-up message interval, the AI Agent will automatically send follow-up messages to potential contacts at the specified time intervals. This ensures timely engagement and improves response rates without requiring manual follow-ups.",
      PleaseEnterInter: "Please enter a positive integer",
      SendNote: "Send a note when adding connections",
      cyes: "yes",
      cno: "no",
      selectNotType: "Select note type",
      pointsolution: "- Pain-point solution",
      Competitorcomparison: "- Competitor comparison",
      Scenario: "- Scenario hypothesis",
      Admiration: "- Admiration & experience",
      relationship: "- Long-term relationship",
      introduction: "- Self-introduction",
      Customcontent: "- Custom content",
      noteTips:
        "1)The note content is automatically personalized for each connection request. The examples below are for reference only. 2)Free LinkedIn accounts can send one request note daily; Premium offers unlimited sends. 3)Free accounts have 200-character note limits vs. Premium's 300 characters.",
      example: "example",
      GenerateExample: "Generate Example",
      Notecontent: "Note content",
      JustEnter:
        "Just enter the content that follows—no need to input names or other fields, as the AI will auto-fill them.",
      PositionOpportunity: "- Position Opportunity",
      Achievement: "- Achievement Appreciation",
      IndustryInsight: "- Industry Insight",
      TalentCommunity: "- Talent Community",
      required: "The item is required",
      ConsultationReport: "Consultation Report",
      StepHintTitle: "Step 1 of 5: name it + connect LinkedIn.",
      StepHintDesc: "Just follow along — about 2 minutes to let AI start working for you!",
      ProHintBtnShow: "I'm a pro, minimize hints",
      ProHintBtnHide: "Minimized · show full notes",
      SafeCardHeader: "Why connect? Is it safe?",
      SafeCardIntro: "Connect LinkedIn to start automating outreach. Here's how we keep your account 100% secure:",
      SafeItemProxyTitle: "Dedicated proxy IP",
      SafeItemProxyDesc: "Matches your usual login location to mimic a local login",
      SafeItemRateTitle: "Human-like rate limits",
      SafeItemRateDesc: "Sends at a natural human pace to stay within limits",
      SafeItemEncryptTitle: "Encrypted storage",
      SafeItemEncryptDesc: "Credentials are encrypted; nothing unrelated is ever done",
      SafeItemDisconnectTitle: "Disconnect anytime",
      SafeItemDisconnectDesc: "Revoke access with one click",
      LearnMoreLink: "Learn how we protect your account →",
      FaCodeBoxTitle: "LinkedIn requires a verification code (2FA)",
      FaCodeBoxDesc: "To confirm it's really you, LinkedIn just sent a <strong class=\"faCodeBox-bold\">6-digit code</strong>. Check <strong class=\"faCodeBox-bold\">any of the channels</strong> below and enter it — this is a normal security check, <strong class=\"faCodeBox-bold\">not an error</strong>.",
      FaCodeChannelAppTitle: "LinkedIn app push",
      FaCodeChannelAppDesc: "Open the signed-in LinkedIn app and tap Yes; no code entry needed",
      FaCodeChannelEmailTitle: "Registered email",
      FaCodeChannelEmailDesc: "Check your inbox or spam folder for the LinkedIn verification code",
      FaCodeChannelAuthTitle: "Authenticator app",
      FaCodeChannelAuthDesc: "Open your linked authenticator and enter its current 6-digit code",
      FaCodeChannelSmsTitle: "SMS",
      FaCodeChannelSmsDesc: "Find the 6-digit code sent to the phone number linked to LinkedIn",
      FaCodeViewLarger: "View larger →",
      FaCodeInputLabel: "If LinkedIn asks for a code, enter the 6 digits",
      LinkedinAccountLabel: "LinkedIn Account",
      LinkedinEmailPlaceholder: "Enter your LinkedIn login email",
      PasswordLabel: "Password",
      PasswordPlaceholder: "your LinkedIn password",
      PasswordTipText: "Tap <span class=\"eye\">👁</span> to reveal and double-check for typos. ",
      TimeZoneLabel: "Time Zone",
      TimeZoneTag: "Selected for your location",
      TimeZoneTipText: "Pick your or your target candidates' time zone; AI sends messages during <strong class=\"input-tip-bold\">local daytime</strong> — more human and safer.",
      ProxyRegionLabel: "Proxy Region",
      ProxyRegionTag: "Recommended",
      ProxyRegionPlaceholder: "United States · matches your usual login",
      ProxyRegionTipText: "Best to match the <strong class=\"input-tip-bold\">region where you usually log in to LinkedIn</strong> to avoid triggering risk controls for an out-of-area login.",
      WorkingHoursLabel: "Working Hours",
      WorkingHoursTag: "Recommended for new accounts",
      WorkingHoursPlaceholder: "Weekdays · daytime hours (safer)",
      WorkingHoursTipText: "<strong class=\"input-tip-bold\">Don't run a new account 24/7</strong> — weekday daytime looks more human and lowers ban risk; open it up gradually once it's warmed up.",
      FaTipsText: "When connecting, LinkedIn may ask for a <strong class=\"faTips-bold\">verification code (2FA)</strong>. A code input will appear and tell you where to find it — <strong class=\"faTips-bold\">app push / registered email / SMS</strong> — so you'll never be stuck.",
      CampaignNameTipText: "Pick a name that's easy to recognize — it <strong class=\"input-tip-bold\">makes managing multiple campaigns easier;</strong> naming by role / region works best.",
      Step2HintTitle: "Step 3 of 5: describe your company, product, and edge clearly so AI can reach customers precisely, answer questions, and drive deals.",
      Step2HintDesc: "Every field has a \"how to fill + what AI does with it\" note. The more specific you are, the more reliable AI's outreach and replies.",
      CompanyInfoTipText: "AI uses it as <strong class=\"input-tip-bold\">background for openers</strong> and to answer \"what does your company do?\" Prefilled from your profile — tweak it for this campaign's target customers.",
      ProductInfoTipText: "Be clear on <strong class=\"input-tip-bold\">features + problems solved + core advantages</strong>. AI uses it to judge fit, generate <strong class=\"input-tip-bold\">personalized outreach</strong>, and answer product questions — the most important field on the sales line.",
      CompetitorInfoTipText: "List main competitors. When a customer <strong class=\"input-tip-bold\">mentions or compares them</strong>, AI knows how to respond and highlight your <strong class=\"input-tip-bold\">differentiators</strong> without getting stuck.",
      SuccessStoriesTipText: "Add 1-2 <strong class=\"input-tip-bold\">customer outcomes / metrics</strong>. AI <strong class=\"input-tip-bold\">uses them at the right moment</strong> to boost credibility and conversion.",
      PricingInfoTipText: "Add hooks like <strong class=\"input-tip-bold\">free trials, pricing, and limited-time offers</strong>. When a customer is interested, AI <strong class=\"input-tip-bold\">brings them up</strong> to drive the next step (trial / order).",
      ContactInfoTipText: "Leave an <strong class=\"input-tip-bold\">email / phone</strong>. When a customer is interested, AI shares it to move the deal forward — <strong class=\"input-tip-bold\">enter at least an email</strong>.",
      CustomContentTipText: "Anything else AI should know (e.g. <strong class=\"input-tip-bold\">industry, ideal customer profile, price range</strong>) — click to add, and AI will use it to answer questions and drive deals.",
      EndTipsInfoText: "This info is only used to help AI understand your company and product; it's <strong class=\"end-tips-bold\">never shown to customers verbatim</strong>; AI references it naturally in context.",
      Step4HintTitle: "Step 4 of 5: set how AI opens, follows up, and what its hard limits are.",
      Step4HintDesc: "This is the last step before launch. Every item has a note; once set, you can \"Watch simulation\" to confirm before publishing.",
      GreetingLanguageLabel: "Greeting language",
      GreetingLanguageTipText: "The language of AI's <strong class=\"input-tip-bold\">first connection message</strong>, match your target candidates (English for North America). Once they reply, AI follows their language automatically.",
      FollowUpMessagesLabel: "Follow-up messages",
      FollowUpMessagesEnabled: "Enabled",
      FollowUpMessagesDisabled: "Disabled",
      FollowUpMessagesTipText: "When on, AI <strong class=\"input-tip-bold\">auto-follows-up</strong> at the interval below if there's no reply, boosting response rates; when off, it sends only one connection message.",
      FollowUpIntervalLabel: "Follow-up interval (days)",
      FollowUpIntervalTipText: "We recommend every <strong class=\"input-tip-bold\">3–5 days</strong>; too frequent annoys people and raises risk-control flags. (No effect when follow-ups are off.)",
      SendNoteLabel: "Send a note with connection requests",
      SendNoteTipText: "Attaching a <strong class=\"input-tip-bold\">short note</strong> to connection requests improves reply rates. Free LinkedIn accounts get 1 noted request per day; Premium is unlimited.",
      NoteTypeLabel: "Note type",
      NoteTypeTipText: "Pick a template by goal; AI <strong class=\"input-tip-bold\">generates a personalized note for each contact</strong> accordingly.&nbsp;&nbsp;<strong class=\"input-tip-bold green\">Recruiting</strong>: Job opportunity / Networking... <strong class=\"input-tip-bold green\">Sales</strong>: Pain-point solving / Competitor comparison... (only this field's note differs by role; all other fields are the same)",
      NoteTipsText: "On character limits: free LinkedIn accounts can send <strong>1</strong> noted request per day, note capped at <strong>200 characters</strong>; Premium accounts have <strong>unlimited requests</strong>, messages capped at <strong>300 characters</strong>. Notes are personalized per candidate; the example below is for reference only.",
      GeneratedExampleLabel: "Generated example",
      GeneratedExampleTag: "Auto-generated from the info above",
      GeneratedExampleTipText: "This is a <strong class=\"input-tip-bold\">real example</strong> AI generated from the info above. To see the full back-and-forth, click \"Watch simulation\" below.",
      ConversationRulesLabel: "Conversation rules (AI's hard limits)",
      ConversationRulesTipText: "Set what AI <strong class=\"input-tip-bold\">can and can't do</strong> here.",
      SkipAllTutorials: "Skip all tutorials",
      TutorialStep2Desc: "Enter your campaign name.",
      TutorialStep3DescWithLink: "Select a LinkedIn Account, and click \"Next Step\".",
      TutorialStep3DescNoLink: "<div class=\"setp1-linkin-txt\">Enter your LinkedIn account and password so the system can send messages on your behalf.</div><div class=\"setp1-linkin-txt\">Select the primary timezone of your potential leads.</div><div class=\"setp1-linkin-txt\">Choose a proxy IP that matches your LinkedIn account's usual login location.</div>",
      TutorialStep4Desc: "Enter the URL and the knowledge base content required for the AI's conversation. The more detailed the input for each field, the more accurate the AI's responses will be.",
      TutorialStep4Desc2: "This information will only be used for the AI's conversations with customers, so please fill it out with confidence.",
      TutorialStep4HowToFindUrl: "How to find a basic search URL?",
      TutorialStep4FindUrl1: "Enter keywords, select \"People\", and filter to narrow down potential leads.",
      TutorialStep4FindUrl2: "Copy the link and paste here.",
      TutorialStep4HowToFindSalesNavUrl: "How to find a sales navigator search URL?",
      TutorialStep4SalesNav1: "Open your browser and visit: https://www.linkedin.com/sales/.",
      TutorialStep4SalesNav2: "Log in to your sales navigator account.",
      TutorialStep4SalesNav3: "Enter keywords and press Enter.",
      TutorialStep4SalesNav4: "Use filters to find leads. Copy the URL and paste it here.",
      TutorialStep5Title1: "1. Initial Greeting Language",
      TutorialStep5Desc1: "Select the language for the AI to greet users, ensuring it is tailored to resonate with the specific linguistic regions of your audience. For example, for Middle Eastern clients, the default language will be English.",
      TutorialStep5Title2: "2. Set the Number of Connections to Be Sent Daily",
      TutorialStep5Desc2: "Define the number of connection requests to be sent daily to maintain an appropriate campaign pace.",
      TutorialStep5Title3: "3. Button Description:",
      TutorialStep5Desc3: "• Save as Draft: Save the current settings as a draft, allowing you to edit and publish them later.",
      TutorialStep5Desc4: "• AI Conversation Demo: Preview the AI's interaction with a simulated user to provide an overview of how it engages in real conversations. This helps identify any missing knowledge inputs.",
      TutorialStep5Desc5: "• Publish Directly: Immediately publish the campaign and apply the current settings to live operations.",
    },
    AR: {
      AddLeads: "إضافةعملاءمحتملين ",
      ChooseYourCustomerSearchMethod: "اختر طريقة البحث عن عملائك",
      InputBasicInformation: "إدخال المعلومات الأساسية قبل إطلاق الحملات",
      CampaignsSettings: "إعدادات الحملات",
      Pleaseenterthecampaignname: "يرجى إدخال اسم الحملة",
      SaveandContinue: "احفظ وتابع",
      back: "العودة",
      SearchMethodSelection: "طريقة اختيار البحث",
      ConnectYourLinkedInAccount: "ربط حساب لينكد إن الخاص بك",
      ConfigureLinkedInProxy: "تكوين الوكيل لينكد إن",
      SelectfromYourConnectedContacts:
        "اختر من جهات الاتصال المتصلة التي تعرفها",
      SearchByUrl: "البحث عن العملاء المستهدفين عبر URL على LinkedIn",
      bindLinkAcc: "LinkedIn أدخل بيانات اعتماد حسابك على ",
      linkEmal: " LinkedIn عنوان البريد الإلكتروني على ",
      linkPwd: "LinkedIn كلمة المرور على ",
      timeZone: "اختر منطقتك الزمنية",
      ConfigureLinkedInProx: "تكوين الوكيل لينكد إن",
      ManualConfiguration: "التكوين اليدوي",
      SelectProxyRegion: "اختر منطقة البروكسي",
      Connect: "اتصال",
      EnterLinkedInSearchURL: "LinkedInأدخل رابط بحث ",
      CompanyInformation: `معلومات الشركة`,
      CompanyInformationCont: `معلومات أساسية: StrategyBrain هي شركة مبتكرة مكرسة لتعزيز قدرات أقسام الموارد البشرية في الشركات الصغيرة والمتوسطة من خلال الذكاء الاصطناعي، وتقليل تكاليف الموارد البشرية، وزيادة تنافسية الشركات الصغيرة والمتوسطة في السوق.
الموقع الرسمي: www.strategybrain.ca
العنوان: تقع StrategyBrain في تورونتو، كندا.
مقدمة الشركة: StrategyBrain ملتزمة باستخدام أحدث تكنولوجيا الذكاء الاصطناعي لحل المشكلات الواقعية، وتقليل عدم المساواة الاجتماعية، وتعزيز التقدم الاجتماعي. هوية الثقافة وإحساس المسؤولية الاجتماعية يوفران أساسًا صلبًا للشركة في تحقيق مهمتها ورؤيتها وقيمها.`,
      ProductInformation: "معلومات المنتج",
      ProductInformationCont: `ميزات المنتج:
1. يساعد المنتج على شكل ذكاء اصطناعي المستخدمين على إيجاد العملاء المحتملين تلقائيًا على LinkedIn، وبناء علاقات تلقائية، والتواصل بشأن نوايا شراء المنتجات، والإجابة على الأسئلة المتعلقة بالمنتجات، وشرح فلسفة تطور الشركة ومزايا المنتج، وتقييم نوايا شراء العملاء.
2. يصمم صورًا للعملاء استنادًا إلى المعلومات المتعلقة بالمنتجات التي تنتظر البيع.
3. يكتشف العملاء تلقائيًا ويتفاعل معهم.
4. يقدم التواصل المبيعاتي الديناميكي المخصص من قبل الذكاء الاصطناعي.`,
      CompetitorInformation: "معلومات المنافسين",
      CompetitorInformationCont:
        "أسماء المنافسين: دوكس-سوب، إكسباندي.آي أو، ميتألفريد",
      SuccessStories: "قصص النجاح",
      SuccessStoriesCont: `الحالة1: تقليل التكاليف وزيادة الكفاءة: أدوات المبيعات الذكية تعزز إنتاجية الموارد البشرية ورضا الموظفين
تطبيق أدوات المبيعات الذكية يمكن أن يقلل التكاليف بشكل ملحوظ ويحسن الكفاءة، مما يعزز إنتاجية الموارد البشرية ورضا الموظفين. دمج حلول BridgePoint B2B Leads Solutions لأداة مبيعات StrategyBrain AI لمواجهة تحديات مثل ارتفاع تكاليف الإدارة، ودوران الموظفين، وعدم كفاءة العمليات، ومحدودية نمو الإيرادات. سمحت قدرات الذكاء الاصطناعي في تصنيف العملاء، والتواصل الشخصي، ومحادثات المبيعات التي تجري على مدار الساعة لفريق المبيعات بالانتقال من المهام المتكررة إلى المبيعات الاستراتيجية، مما أدى إلى تحسين الكفاءة العامة بشكل كبير وتقليل التكاليف التشغيلية. نتيجة لذلك، أدى التطبيق إلى تقليل التكاليف التشغيلية بنسبة 60٪، وزيادة رضا الموظفين بنسبة 20٪، ونمو الإيرادات بنسبة 5٪، مما ساهم بنجاح في توسيع نطاق الشركة في السوق العالمية.
الحالة2: ......`,
      PricingInformation: "معلومات التسعير",
      PricingInformationCont: `التجربة المجانية: اختبر المنتج مجاناً عبر التسجيل المباشر وتجربته.
سعر الاشتراك: 9.90 دولار أمريكي شهرياً
الخصم المتوفر: نعم، اشترك بسعر 9.90 دولار شهرياً`,
      ContactInformation: "معلومات الاتصال",
      ContactInformationCont: `البريد الإلكتروني:
الهاتف:`,
      addMore: "أضف المزيد من المعلومات",
      CustomContent: "محتوى مخصص",
      inputCustomContent: "الرجاء إدخال المحتوى المخصص",
      BriefSummary: "ملخص موجز",
      BriefSummaryIntro: `سيساعد الملخص المختصر StrategyBrain على فهم شركتك ومنتجاتك بشكل أفضل. الرجاء التأكد من تضمين جميع النقاط الرئيسية.`,
      SetConversationLimits: "تحديدات المحادثة",
      SetConversationLimitsCont: `هنا يمكنك تعيين قيود على ما يمكن للروبوت قوله. على سبيل المثال: 1. لا تروي نكات للمستخدمين. 2. لا محتوى سياسي.
`,
      dianzan:
        "قم تلقائيًا بالإعجاب بالمنشور الأول عند الاتصال بالعملاء المحتملين",
      capaginName: "اسم الحملة",

      inputLinkAccount: "يرجى اختيار حسابك على LinkedIn",
      inputContent: "يرجى إدخال المحتوى",
      rightAccount: "يرجى إدخال بريد إلكتروني صالح لحساب LinkedIn",
      inputPwd: "يرجى إدخال كلمة المرور",
      selectTimezone: "يرجى اختيار المنطقة الزمنية",
      selectRegion: "يرجى اختيار منطقة الوكيل",
      selectUrl: "يرجى إدخال رابط LinkedIn صالح",
      editTitle: "يرجى تعديل العنوان المخصص",
      shortDes: "يرجى إدخال الوصف القصير",
      dialogLimit: "يرجى إدخال حد المحادثة",
      All: "الجميع",
      bindTips:
        "كن مستعدًا لتأكيد رمز PIN الخاص بحسابك على LinkedIn بسبب التحقق بخطوتين. سيتم إرساله بواسطة LinkedIn إلى عنوان البريد الإلكتروني لحسابك على LinkedIn. بناءً على إعدادات الأمان، قد يتم إرساله أيضًا عبر الرسائل النصية القصيرة (SMS).",
      inputCode: "يرجى إدخال الرمز",
      confirmDel: "هل أنت متأكد أنك تريد حذف هذه المهمة؟",
      NextStep: "التالي",

      Account: "الحساب",
      TimeZone: "المنطقة الزمنية",
      Proxy: "الوكيل",
      Connected: "متصل",
      ObtainProxyIP: "الحصول على عنوان IP للوكيل",
      VerifyLink: "التحقق من كلمة مرور حساب LinkedIn",
      LinkedInAccountLink: "رابط حساب LinkedIn",
      ContinueConnect: "متابعة الربط",
      selectHistory: "يتم تحميل البيانات",
      findUrl: " كيفية العثور على رابط LinkedIn",
      loginAccount: " قم بتسجيل الدخول إلى حساب LinkedIn الخاص بك",
      Enterkeywords: ` أدخل الكلمات الرئيسية في مربع البحث، ثم اضغط على Enter أو "عرض كل النتائج"`,
      SelectThePeople: `- اختر فلتر "الأشخاص"، وقم بتعيين المزيد من معايير البحث في الفلاتر، ثم انقر على "عرض النتائج"`,
      copyURL: ` انسخ عنوان URL من شريط التنقل إلى مربع الإدخال هذا`,
      ReferenceDocument: `- الوثيقة المرجعية`,
      conversationRestrictions: `٣. على سبيل المثال، رفض إلقاء النكات`,
      Save: `حفظ`,
      SelectThePeopleRed: `ملاحظة مهمة: عند استخدام الفلتر، يرجى التحقق من اتصالاتك. لإرسال رسائل إلى اتصالاتك الحالية، اختر "الدرجة الأولى". إذا كنت لا تريد إرسال رسائل إلى اتصالاتك، قم بإلغاء تحديد هذا الخيار. بعد ذلك، اختر فقط اتصالات "الدرجة الثانية" و"الدرجة الثالثة+`,
      bindLinkAccTipTitle1: "كيف تربط حسابك على LinkedIn؟",
      bindLinkAccTipcon1: `أدخل اسم المستخدم وكلمة المرور لحسابك على LinkedIn. ثم اختر منطقتك الزمنية وإعدادات البروكسي. أخيرًا، انقر على ""اتصال"". سيبدأ النظام في التحقق من حساب LinkedIn الخاص بك. إذا قام النظام بمقاطعة الاتصال، يرجى اتباع التعليمات التي تظهر على الشاشة. إذا لم تتمكن من ربط حسابك بعد ذلك، يرجى الاتصال بالدعم الفني.`,
      bindLinkAccTipTitle2: "هل جميع أنواع حسابات LinkedIn مدعومة؟",
      bindLinkAccTipcon2:
        "لا. قبل ربط حسابك على LinkedIn، يُرجى التحقق من أنه يمكنه إرسال طلبات اتصال. إذا كان حسابك لا يمكنه إضافة اتصالات، فلن يتمكن أداة الأتمتة من تنفيذ الحملات المتعلقة بذلك.",
      bindLinkAccTipcon3: `يمكنك أولاً زيادة مستوى نشاطك على LinkedIn من خلال:
إكمال ملفك الشخصي.
نشر ومشاركة المحتوى
المشاركة في التفاعلات مع الآخرين.
يرجى محاولة ربط حسابك مرة أخرى بعد أن تتمكن من إرسال طلبات اتصال.`,
      bindLinkAccTipBtn: "انقر",
      bindLinkAccTipBtnTxt: " هنا لعرض الوثائق التفصيلية.",
      step3TipTitle: "حدود طلبات الاتصال",
      step3TipCon:
        "لتجنب تفعيل أمان LinkedIn، يرجى تحديد عدد طلبات الاتصال اليومية لكل حساب.",
      step3TipCon1: `نوصي بعدم تجاوز 20 طلبًا يوميًا للحسابات العادية.
نوصي بعدم تجاوز 35 طلبًا يوميًا لحسابات النافيغيتور.`,
      step3TipTitle2: "ساعات عمل الحساب",
      step3TipCon2:
        "يعمل كل حساب LinkedIn وفق جدول عمل يومي مدته 8 ساعات. تحدد المنطقة الزمنية المختارة حسب إعدادات البروكسي التوقيت المحلي. سيقوم الحساب بالبحث وإرسال طلبات الاتصال والدردشة خلال هذه الساعات. ستتوقف العمليات خارج ساعات العمل، وستستأنف في يوم العمل التالي عندما تبدأ ساعات العمل مرة أخرى.",
      Confirm: "تأكيد",
      Cancel: "إلغاء",
      TheAccountIsBeingBound:
        "يتم ربط الحساب حالياً. هل أنت متأكد أنك تريد المغادرة؟",
      campaignEditStep2Tip:
        "قد يؤدي تعديل المحتوى إلى تعطيل المحادثة بين الذكاء الاصطناعي والمستخدم، مما يسبب اختلالًا في السياق أو حوارًا مفصولًا. يرجى التحرير بحذر، مع إجراء تعديلات طفيفة فقط لتجنب تغيير الموضوع.",
      saveDraftBtn: "حفظ كمسودة",
      saveDraftSuccess: "تم حفظه في المسودات",
      InitialGreetingLanguage: "لغة التحية الأولية",
      InitialGreetingLanguageErr: "يرجى اختيار لغة التحية",
      PublishDirectly: "النشر مباشرة",
      ViewSimulation: "عرض المحاكاة",
      PreReviewEyebrow: "الخطوة التالية الموصى بها",
      PreReviewTitle: "اكتمل الإعداد، جاهز للمراجعة قبل الإطلاق",
      PreReviewDesc:
        "سنسترد العملاء المحتملين الحقيقيين وننشئ معاينة. لن يتم إرسال أي رسائل الآن؛ وسيظل المستخدمون الذين لا يملكون طريقة دفع بحاجة إلى تأكيد واحدة قبل الإطلاق.",
      PreLaunchReview: "مراجعة ما قبل الإطلاق",
      AfterReview: "بعد المراجعة",
      AIStyleSettings: "إعدادات نمط الذكاء الاصطناعي",
      step3NoteTipTitle: "ملاحظة",
      step3TipDes1: `“حفظ كمسودة” يخزن الحملة في صندوق المسودات للتحرير والنشر لاحقاً.`,
      step3TipDes2: `“عرض المحاكاة” يسمح لك برؤية كيفية تفاعل الذكاء الاصطناعي مع المستخدمين بناءً على مدخلاتك. يمكنك النشر بعد ذلك.`,
      step3TipDes3: `“النشر مباشرة” يتخطى المحاكاة وينشر فوراً.`,
      step3TipDes4: `يرجى ملاحظة أنه إذا استجاب المستخدم لأول مرة بلغة مختلفة عن تلك المستخدمة من قبل الذكاء الاصطناعي، فسيقوم الذكاء الاصطناعي تلقائيًا بالتبديل للتواصل باللغة المقابلة.`,
      step3TipDes5: `الحوارات التوضيحية للذكاء الاصطناعي ليست تمثيلًا دقيقًا للتفاعلات الواقعية، حيث تعتمد على خلفية العميل وسياق المحادثة الفعلي. تم تصميم هذه الميزة لتزويد العملاء بفهم عام لقدرات التواصل الخاصة بالذكاء الاصطناعي، لمساعدتهم على التحضير لاختبارات التطبيقات الواقعية.`,
      CampaignsSimulation: "محاكاة المحادثة",
      step4Des: `نستخدم مدخلاتك لمحاكاة كيفية تحقيق الذكاء الاصطناعي لأهداف عملك خطوة بخطوة. المحادثة المحاكاة مخصصة بناءً على الملف الشخصي المختار والمعلومات التي قدمتها. إذا لم تحقق النتائج المتوقعة، يمكنك تعديل المدخلات حتى تحقق النتيجة المرغوبة.`,
      noFirstCampaignTip:
        "هذا هو الإصدار التجريبي المجاني. يُرجى ترقية حسابك لإنشاء حملات غير محدودة.",
      LinkedinAvailabilitySchedule: "جدول التوفر على LinkedIn",
      AlwaysOn: "العمل على مدار الساعة طوال أيام الأسبوع ",
      BusinessHoursMS: "من الاثنين إلى الجمعة، من 8 صباحًا حتى 7 مساءً",
      BusinessHoursMF: "من الاثنين إلى الأحد، من 8 صباحًا حتى 7 مساءً",
      workTimeDes:
        "قد يؤدي النشاط على مدار الساعة (24/7) أو من الاثنين إلى الأحد إلى تنبيه نظام LinkedIn. يرجى التحقق من حسابك لتجنب خطر التعليق.",
      verifyyourLinkedIn: `<a href="https://www.strategybrain.ca/a-practical-guide-to-linkedin-verification-and-recovery-for-strategybrain-users/" target="_blank">يرجى التحقق من حساب LinkedIn</a>  الخاص بك قبل استخدام أي أدوات أتمتة طرف ثالث. دليل التحقق من حساب LinkedIn`,
      Avoidswitchingaccounts: `تجنب تبديل الحسابات بشكل متكرر، حيث يزيد ذلك من المخاطر.<a href="mailto:info@strategybrain.ca"> اتصل بنا</a> للتبديل (قد تطبق رسوم خدمة صغيرة).`,
      In: "الاشتراك",
      Out: "إلغاء الاشتراك",
      OptInOut: "الاشتراك/إلغاء الاشتراك",
      SetFollowMessageStatus: "تعيين حالة رسائل المتابعة",
      Yes: "الاشتراك",
      No: "إلغاء الاشتراك",
      SetIntervaldays: "تعيين فترة أيام رسائل المتابعة",
      SettingFollowMessage:
        "تحديد فترة رسائل المتابعة، سيقوم الوكيل الذكي تلقائيًا بإرسال رسائل متابعة إلى جهات الاتصال المحتملة في فترات زمنية محددة. يضمن ذلك المشاركة في الوقت المناسب ويحسن معدلات الاستجابة دون الحاجة إلى متابعات يدوية.",
      PleaseEnterInter: "الرجاء إدخال عدد صحيح موجب",
      SendNote: "إرسال ملاحظة عند إضافة اتصالات",
      cyes: "نعم",
      cno: "لا",
      selectNotType: "اختر نوع الملاحظة",
      pointsolution: "حلول نقاط الألم",
      Competitorcomparison: "مقارنة المنافسين",
      Scenario: "فرضية السيناريو",
      Admiration: "الإعجاب والخبرة",
      relationship: "علاقة طويلة الأجل",
      introduction: "مقدمة ذاتية",
      Customcontent: "محتوى مخصص",
      noteTips:
        "1)يتم تخصيص محتوى الملاحظة تلقائيًا لكل طلب اتصال. الأمثلة أدناه للإشارة فقط. 2)يمكن للحسابات المجانية على لينكدإن إرسال ملاحظة طلب واحدة يوميًا؛ بينما تقدم Premium إرسال غير محدود. 3)الحسابات المجانية لها حد 200 حرف للملاحظة مقابل 300 حرف لـ Premium.",
      example: "مثال",
      GenerateExample: "إنشاء مثال",
      Notecontent: "محتوى الملاحظة",
      JustEnter:
        "فقط أدخل المحتوى التالي - لا حاجة لإدخال أسماء أو حقول أخرى، حيث أن الذكاء الاصطناعي سيملؤها تلقائيًا.",
      PositionOpportunity: "فرصة وظيفية",
      Achievement: "تقدير الإنجاز",
      IndustryInsight: "رؤية قطاعية",
      TalentCommunity: "مجتمع المواهب",
      required: "هذا هو المطلوب",
      ConsultationReport: "تقرير الاستشارة",
      StepHintTitle: "الخطوة 1 من 5: التسمية + ربط LinkedIn",
      StepHintDesc: "ما عليك سوى المتابعة — حوالي دقيقتين لبدء عمل الذكاء الاصطناعي من أجلك!",
      ProHintBtnShow: "أنا محترف، إخفاء التلميحات",
      ProHintBtnHide: "تم الإخفاء · إظهار الملاحظات الكاملة",
      SafeCardHeader: "لماذا الربط؟ هل هو آمن؟",
      SafeCardIntro: "قم بربط LinkedIn لبدء أتمتة التواصل. إليك كيف نحافظ على أمان حسابك بنسبة 100٪:",
      SafeItemProxyTitle: "عنوان IP وكيل مخصص",
      SafeItemProxyDesc: "يطابق موقع تسجيل الدخول المعتاد لمحاكاة تسجيل الدخول المحلي",
      SafeItemRateTitle: "حدود معدل تشبه الإنسان",
      SafeItemRateDesc: "يرسل بوتيرة بشرية طبيعية للبقاء ضمن الحدود",
      SafeItemEncryptTitle: "تخزين مشفر",
      SafeItemEncryptDesc: "بيانات الاعتماد مشفرة؛ لن يتم أبدًا القيام بأي شيء غير ذي صلة",
      SafeItemDisconnectTitle: "قطع الاتصال في أي وقت",
      SafeItemDisconnectDesc: "إلغاء الوصول بنقرة واحدة",
      LearnMoreLink: "تعرف على كيفية حماية حسابك ←",
      FaCodeBoxTitle: "يتطلب LinkedIn رمز التحقق (المصادقة الثنائية)",
      FaCodeBoxDesc: "لتأكيد أنه أنت حقًا، أرسل LinkedIn للتو <strong class=\"faCodeBox-bold\">رمز مكون من 6 أرقام</strong>. تحقق من <strong class=\"faCodeBox-bold\">أي من القنوات</strong> أدناه وأدخله — هذا فحص أمني طبيعي، <strong class=\"faCodeBox-bold\">ليس خطأ</strong>.",
      FaCodeChannelAppTitle: "دفع تطبيق LinkedIn",
      FaCodeChannelAppDesc: "افتح تطبيق LinkedIn الذي سجلت دخولك إليه وانقر على نعم؛ لا حاجة لإدخال رمز",
      FaCodeChannelEmailTitle: "البريد الإلكتروني المسجل",
      FaCodeChannelEmailDesc: "تحقق من صندوق الوارد أو مجلد البريد العشوائي بحثًا عن رمز تحقق LinkedIn",
      FaCodeChannelAuthTitle: "تطبيق المصادقة",
      FaCodeChannelAuthDesc: "افتح تطبيق المصادقة المرتبط وأدخل رمزه الحالي المكون من 6 أرقام",
      FaCodeChannelSmsTitle: "رسالة نصية",
      FaCodeChannelSmsDesc: "ابحث عن الرمز المكون من 6 أرقام المرسل إلى رقم الهاتف المرتبط بـ LinkedIn",
      FaCodeViewLarger: "عرض أكبر ←",
      FaCodeInputLabel: "إذا طلب LinkedIn رمزًا، فأدخل الأرقام الستة",
      LinkedinAccountLabel: "حساب LinkedIn",
      LinkedinEmailPlaceholder: "أدخل بريد تسجيل الدخول الخاص بك على LinkedIn",
      PasswordLabel: "كلمة المرور",
      PasswordPlaceholder: "كلمة مرور LinkedIn الخاصة بك",
      PasswordTipText: "انقر على <span class=\"eye\">👁</span> لإظهارها والتحقق منها بعناية لتجنب الأخطاء الإملائية. ",
      TimeZoneLabel: "المنطقة الزمنية",
      TimeZoneTag: "مختارة لموقعك",
      TimeZoneTipText: "اختر منطقتك الزمنية أو منطقة المرشحين المستهدفين؛ يرسل الذكاء الاصطناعي الرسائل خلال <strong class=\"input-tip-bold\">ساعات النهار المحلية</strong> — أكثر إنسانية وأكثر أمانًا.",
      ProxyRegionLabel: "منطقة الوكيل",
      ProxyRegionTag: "موصى به",
      ProxyRegionPlaceholder: "الولايات المتحدة · يطابق تسجيل الدخول المعتاد",
      ProxyRegionTipText: "من الأفضل مطابقة <strong class=\"input-tip-bold\">المنطقة التي تسجل فيها الدخول عادةً إلى LinkedIn</strong> لتجنب تفعيل ضوابط المخاطر لتسجيل الدخول من خارج المنطقة.",
      WorkingHoursLabel: "ساعات العمل",
      WorkingHoursTag: "موصى به للحسابات الجديدة",
      WorkingHoursPlaceholder: "أيام الأسبوع · ساعات النهار (أكثر أمانًا)",
      WorkingHoursTipText: "<strong class=\"input-tip-bold\">لا تقم بتشغيل حساب جديد على مدار الساعة طوال أيام الأسبوع</strong> — يبدو نهار أيام الأسبوع أكثر إنسانية ويقلل من خطر الحظر؛ افتحه تدريجيًا بمجرد أن يصبح دافئًا.",
      FaTipsText: "عند الاتصال، قد يطلب LinkedIn <strong class=\"faTips-bold\">رمز التحقق (المصادقة الثنائية)</strong>. سيظهر إدخال رمز ويخبرك أين تجده — <strong class=\"faTips-bold\">دفع التطبيق / البريد الإلكتروني المسجل / رسالة نصية</strong> — لذا لن تتوقف أبدًا.",
      CampaignNameTipText: "اختر اسمًا سهل التعرف عليه — إنه <strong class=\"input-tip-bold\">يجعل إدارة حملات متعددة أسهل؛</strong> التسمية حسب الدور / المنطقة تعمل بشكل أفضل.",
      Step2HintTitle: "الخطوة 3 من 5: صف شركتك ومنتجك وميزتك بوضوح حتى يتمكن الذكاء الاصطناعي من الوصول إلى العملاء بدقة والإجابة على الأسئلة وإتمام الصفقات.",
      Step2HintDesc: "كل حقل له ملاحظة \"كيفية التعبئة + ما يفعله الذكاء الاصطناعي بها\". كلما كنت أكثر تحديدًا، كلما كان تواصل الذكاء الاصطناعي وردوده أكثر موثوقية.",
      CompanyInfoTipText: "يستخدمه الذكاء الاصطناعي ك<strong class=\"input-tip-bold\">خلفية للافتتاحيات</strong> وللإجابة على \"ماذا تفعل شركتك؟\" تم تعبئته مسبقًا من ملفك الشخصي — قم بتعديله للعملاء المستهدفين في هذه الحملة.",
      ProductInfoTipText: "كن واضحًا بشأن <strong class=\"input-tip-bold\">الميزات + المشاكل المحلولة + المزايا الأساسية</strong>. يستخدمه الذكاء الاصطناعي للحكم على الملاءمة، وإنشاء <strong class=\"input-tip-bold\">تواصل مخصص</strong>، والإجابة على أسئلة المنتج — أهم حقل في خط المبيعات.",
      CompetitorInfoTipText: "اذكر المنافسين الرئيسيين. عندما <strong class=\"input-tip-bold\">يذكر العميل أو يقارنهم</strong>، يعرف الذكاء الاصطناعي كيفية الرد وتسليط الضوء على <strong class=\"input-tip-bold\">مميزاتك</strong> دون التوقف.",
      SuccessStoriesTipText: "أضف 1-2 من <strong class=\"input-tip-bold\">نتائج/مقاييس العملاء</strong>. يستخدمها الذكاء الاصطناعي <strong class=\"input-tip-bold\">في اللحظة المناسبة</strong> لتعزيز المصداقية والتحويل.",
      PricingInfoTipText: "أضف عوامل جذب مثل <strong class=\"input-tip-bold\">التجارب المجانية والأسعار والعروض محدودة الوقت</strong>. عندما يكون العميل مهتمًا، <strong class=\"input-tip-bold\">يذكرها الذكاء الاصطناعي</strong> لدفع الخطوة التالية (تجربة/طلب).",
      ContactInfoTipText: "اترك <strong class=\"input-tip-bold\">بريدًا إلكترونيًا/هاتفًا</strong>. عندما يكون العميل مهتمًا، يشاركه الذكاء الاصطناعي لتحريك الصفقة — <strong class=\"input-tip-bold\">أدخل بريدًا إلكترونيًا على الأقل</strong>.",
      CustomContentTipText: "أي شيء آخر يجب أن يعرفه الذكاء الاصطناعي (مثل <strong class=\"input-tip-bold\">الصناعة وملف العميل المثالي ونطاق السعر</strong>) — انقر للإضافة، وسيستخدمه الذكاء الاصطناعي للإجابة على الأسئلة وإتمام الصفقات.",
      EndTipsInfoText: "تُستخدم هذه المعلومات فقط لمساعدة الذكاء الاصطناعي على فهم شركتك ومنتجك؛ <strong class=\"end-tips-bold\">لا تُعرض أبدًا على العملاء حرفيًا</strong>؛ يشير إليها الذكاء الاصطناعي بشكل طبيعي في السياق.",
      Step4HintTitle: "الخطوة 4 من 5: حدد كيف يفتح الذكاء الاصطناعي ويتابع وما هي حدوده الصارمة.",
      Step4HintDesc: "هذه هي الخطوة الأخيرة قبل الإطلاق. كل عنصر له ملاحظة؛ بمجرد الإعداد، يمكنك \"مشاهدة المحاكاة\" للتأكيد قبل النشر.",
      GreetingLanguageLabel: "لغة التحية",
      GreetingLanguageTipText: "لغة <strong class=\"input-tip-bold\">رسالة الاتصال الأولى</strong> للذكاء الاصطناعي، طابق المرشحين المستهدفين (الإنجليزية لأمريكا الشمالية). بمجرد ردهم، يتبع الذكاء الاصطناعي لغتهم تلقائيًا.",
      FollowUpMessagesLabel: "رسائل المتابعة",
      FollowUpMessagesEnabled: "مفعّل",
      FollowUpMessagesDisabled: "معطّل",
      FollowUpMessagesTipText: "عند التشغيل، <strong class=\"input-tip-bold\">يتابع الذكاء الاصطناعي تلقائيًا</strong> في الفاصل الزمني أدناه إذا لم يكن هناك رد، مما يعزز معدلات الاستجابة؛ عند الإيقاف، يرسل رسالة اتصال واحدة فقط.",
      FollowUpIntervalLabel: "فاصل المتابعة (أيام)",
      FollowUpIntervalTipText: "نوصي بكل <strong class=\"input-tip-bold\">3-5 أيام</strong>؛ التكرار الكثير يزعج الناس ويثير علامات التحكم في المخاطر. (لا تأثير عند إيقاف المتابعات.)",
      SendNoteLabel: "إرسال ملاحظة مع طلبات الاتصال",
      SendNoteTipText: "إرفاق <strong class=\"input-tip-bold\">ملاحظة قصيرة</strong> بطلبات الاتصال يحسن معدلات الرد. تحصل حسابات LinkedIn المجانية على طلب واحد مع ملاحظة يوميًا؛ Premium غير محدود.",
      NoteTypeLabel: "نوع الملاحظة",
      NoteTypeTipText: "اختر قالبًا حسب الهدف؛ <strong class=\"input-tip-bold\">يولد الذكاء الاصطناعي ملاحظة مخصصة لكل جهة اتصال</strong> وفقًا لذلك.&nbsp;&nbsp;<strong class=\"input-tip-bold green\">التوظيف</strong>: فرصة عمل/تواصل... <strong class=\"input-tip-bold green\">المبيعات</strong>: حل نقاط الألم/مقارنة المنافسين... (فقط ملاحظة هذا الحقل تختلف حسب الدور؛ جميع الحقول الأخرى متماثلة)",
      NoteTipsText: "حول حدود الأحرف: يمكن لحسابات LinkedIn المجانية إرسال <strong>1</strong> طلب مع ملاحظة يوميًا، الملاحظة محدودة بـ <strong>200 حرف</strong>؛ حسابات Premium لها <strong>طلبات غير محدودة</strong>، الرسائل محدودة بـ <strong>300 حرف</strong>. يتم تخصيص الملاحظات لكل مرشح؛ المثال أدناه للمرجع فقط.",
      GeneratedExampleLabel: "مثال تم إنشاؤه",
      GeneratedExampleTag: "تم إنشاؤه تلقائيًا من المعلومات أعلاه",
      GeneratedExampleTipText: "هذا <strong class=\"input-tip-bold\">مثال حقيقي</strong> أنشأه الذكاء الاصطناعي من المعلومات أعلاه. لرؤية المحادثة الكاملة، انقر على \"مشاهدة المحاكاة\" أدناه.",
      ConversationRulesLabel: "قواعد المحادثة (حدود الذكاء الاصطناعي الصارمة)",
      ConversationRulesTipText: "حدد ما <strong class=\"input-tip-bold\">يمكن وما لا يمكن</strong> للذكاء الاصطناعي القيام به هنا.",
      SkipAllTutorials: "تخطي جميع البرامج التعليمية",
      TutorialStep2Desc: "أدخل اسم حملتك.",
      TutorialStep3DescWithLink: "حدد حساب LinkedIn، وانقر على \"التالي\".",
      TutorialStep3DescNoLink: "<div class=\"setp1-linkin-txt\">أدخل حساب LinkedIn وكلمة المرور الخاصة بك حتى يتمكن النظام من إرسال الرسائل نيابة عنك.</div><div class=\"setp1-linkin-txt\">حدد المنطقة الزمنية الأساسية لمرشحيك المحتملين.</div><div class=\"setp1-linkin-txt\">اختر عنوان IP للوكيل يطابق موقع تسجيل الدخول المعتاد لحساب LinkedIn الخاص بك.</div>",
      TutorialStep4Desc: "أدخل URL ومحتوى قاعدة المعرفة المطلوب لمحادثة الذكاء الاصطناعي. كلما كان الإدخال أكثر تفصيلاً لكل حقل، كانت ردود الذكاء الاصطناعي أكثر دقة.",
      TutorialStep4Desc2: "ستُستخدم هذه المعلومات فقط لمحادثات الذكاء الاصطناعي مع العملاء، لذا يرجى تعبئتها بثقة.",
      TutorialStep4HowToFindUrl: "كيفية العثور على URL بحث أساسي؟",
      TutorialStep4FindUrl1: "أدخل الكلمات الرئيسية، حدد \"الأشخاص\"، وقم بالتصفية لتضييق نطاق العملاء المحتملين.",
      TutorialStep4FindUrl2: "انسخ الرابط والصقه هنا.",
      TutorialStep4HowToFindSalesNavUrl: "كيفية العثور على URL بحث Sales Navigator؟",
      TutorialStep4SalesNav1: "افتح متصفحك وقم بزيارة: https://www.linkedin.com/sales/.",
      TutorialStep4SalesNav2: "سجل الدخول إلى حساب Sales Navigator الخاص بك.",
      TutorialStep4SalesNav3: "أدخل الكلمات الرئيسية واضغط Enter.",
      TutorialStep4SalesNav4: "استخدم الفلاتر للعثور على العملاء المحتملين. انسخ URL والصقه هنا.",
      TutorialStep5Title1: "1. لغة التحية الأولية",
      TutorialStep5Desc1: "حدد اللغة التي يستخدمها الذكاء الاصطناعي لتحية المستخدمين، مع التأكد من أنها مصممة لتتوافق مع المناطق اللغوية المحددة لجمهورك. على سبيل المثال، للعملاء في الشرق الأوسط، ستكون اللغة الافتراضية هي الإنجليزية.",
      TutorialStep5Title2: "2. تعيين عدد الاتصالات التي سيتم إرسالها يوميًا",
      TutorialStep5Desc2: "حدد عدد طلبات الاتصال التي سيتم إرسالها يوميًا للحفاظ على إيقاع الحملة المناسب.",
      TutorialStep5Title3: "3. وصف الأزرار:",
      TutorialStep5Desc3: "• حفظ كمسودة: احفظ الإعدادات الحالية كمسودة، مما يتيح لك تحريرها ونشرها لاحقًا.",
      TutorialStep5Desc4: "• عرض محاكاة AI: معاينة تفاعل الذكاء الاصطناعي مع مستخدم محاكي لتوفير نظرة عامة على كيفية مشاركته في المحادثات الحقيقية. هذا يساعد في تحديد أي مدخلات معرفة مفقودة.",
      TutorialStep5Desc5: "• النشر مباشرة: انشر الحملة فورًا وطبق الإعدادات الحالية على العمليات المباشرة.",
    },
  },
};
